import './defect-alteration-view.scss'

import { faCheck, faTimes, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FormApi } from 'final-form';
import Component from 'vue-class-component';

import { DefectAlteration } from '@skinsoft/entity';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { DeleteValidationOverlay, EnhancedTextInput, getTranslatedString, ThesaurusTermChooser } from '@skinsoft/ui';

import { Watch } from 'vue-property-decorator';
import { DefectAnnotationsView } from '../defect-annotations-view';
@Component({
    components: {
        sDefectAnnotationsView: DefectAnnotationsView,
        sDeleteValidationOverlay: DeleteValidationOverlay,
        sEnhancedTextInput: EnhancedTextInput,
        sThesaurusTermChooser: ThesaurusTermChooser,
    },
    props: ['form', 'fieldName', 'defectAlteration', 'currentMaterialTermId', 'alterationIndex', 'currentTypeOfObsTermId', 'elementName', 'deletable'],
    template: require('./defect-alteration-view.html')
})
export class DefectAlterationView extends ReactiveVue {

    public form: FormApi;
    public fieldName: string;
    // Currently selected material in parent, used to adapt select options for type of alteration choice
    public currentMaterialTermId: string;
    public defectAlteration: DefectAlteration
    public alterationIndex: number;
    public currentTypeOfObsTermId: string;
    public elementName: string;
    public deletable: boolean;

    private getTranslatedString = getTranslatedString;

    // icons
    private deleteIcon = faTrash;
    private crossIcon = faTimes;
    private checkIcon = faCheck;

    private displayDeleteOverlay: boolean = false;

    public mounted() {
        // Catching delete-overlay events
        this.$on('deletion-validated-topic', this.deleteAlteration)
        this.$on('deletion-canceled-topic', this.toggleOverlay)
    }

    public get defectAnnotations() {
        if (!this.defectAlteration.annotations) {
            this.defectAlteration.annotations = []
        }
        return this.defectAlteration.annotations;
    }

    public get typeOfAlterationFieldName() {
        return `${this.fieldName}.typeOfAlteration`
    }

    public get precisionFieldName() {
        return `${this.fieldName}.precision.translatedString.${this.$i18n.locale}`
    }

    public get annotationsFieldName() {
        return `${this.fieldName}.annotations`
    }

    public deleteAlteration() {
        this.$parent.$emit('delete-alteration', { alterationIndex: this.alterationIndex })
    }

    public createAlteration() {
        this.$parent.$emit('create-alteration')
    }

    public toggleOverlay() {
        this.displayDeleteOverlay = !this.displayDeleteOverlay
    }

    private get breadcrumbObject() {
        return {
            alterationId: this.defectAlteration.typeOfAlteration,
            elementName: this.elementName,
            materialId: this.currentMaterialTermId,
            observationId: this.currentTypeOfObsTermId
        }
    }

    @Watch('defectAlteration')
    public onDefectAlterationChange() {
        this.displayDeleteOverlay = false;
    }

}